export const searchApiFactory = ({ callGetApi }) => ({
    omniboxSearch: query => callGetApi('/search', { query }),
});
